import create from "zustand";

export interface ComponentState {
  componentId: string;
  groupId: string;
  setComponentId: (componentId: string) => void;
  setGroupId: (groupId: string) => void;
}

const createComponentStore = (initialState: Partial<ComponentState> = {}) => {
  return create<ComponentState>(set => ({
    componentId: initialState.componentId || "",
    groupId: initialState.groupId || "",
    setComponentId: componentId => set({ componentId }),
    setGroupId: groupId => set({ groupId }),
  }));
};

export default createComponentStore;
